import { isEmpty, isNaN, isNumber, last, some, toPath } from 'lodash';

import { mapAudienceTargetingsToRetargetingConditionsApiFormat } from '../../mappers/retargetingCondition/retargetingCondition';
import {
    ValidationErrorData,
    ValidationErrorsData
} from '../../typings/common';
import { CryptaSegmentsByType } from '../../typings/cryptaSegments';
import { CampaignType, GroupType } from '../../typings/domain';
import { GroupId } from '../../typings/groups';
import {
    AudienceCollection,
    CpmGroupShowConditionType,
    EditGroupData,
    EditGroupDataValue
} from '../../typings/groupsEditState';

export function cutErrors(
    errors: ValidationErrorsData,
    currentError: ValidationErrorData[] = []
): ValidationErrorsData {
    if (!isEmpty(currentError)) {
        currentError.forEach(error => {
            const index = Number(last(toPath(error.path)));
            if (isNumber(index)) {
                if (isNaN(index)) {
                    errors = {};
                } else {
                    errors[index].errors = [];
                }
            }
        });
    }

    return errors;
}

export const getGroupAudienceCollection = (
    groupValue: EditGroupDataValue
): AudienceCollection[] | undefined => {
    switch (groupValue.campaignType) {
        case CampaignType.CPM_BANNER:
            return groupValue.audienceCollection;
        default:
            return;
    }
};

export function isUserProfileEmpty(
    groupsDataToSave: Record<GroupId, EditGroupData>,
    cryptaSegmentsByType: CryptaSegmentsByType
): boolean {
    return some(groupsDataToSave, (group: EditGroupData) => {
        const groupVal = group.value;

        if (
            groupVal.campaignType === CampaignType.CPM_BANNER &&
            groupVal.showConditionType ===
                CpmGroupShowConditionType.USER_PROFILE &&
            groupVal.groupType !== GroupType.CPM_INDOOR &&
            groupVal.groupType !== GroupType.CPM_OUTDOOR
        ) {
            const groupUserProfile = mapAudienceTargetingsToRetargetingConditionsApiFormat(
                {
                    audienceTargetings: groupVal.audienceTargetings,
                    audienceTargetingsTemplateName:
                        groupVal.audienceTargetingsTemplateName,
                    cryptaSegmentsByType
                }
            );

            if (groupUserProfile) {
                return !groupUserProfile.conditionRules.length;
            } else {
                return true;
            }
        }

        return false;
    });
}
